import { AssuranceEmprunteur } from "./assuranceEmprunteur";

export const Assurance = () => {
  return (
    <div className="flex gap-5 placeholder:px-2 sm:px-4pt-4 pb-20 md:pr-6">
      <AssuranceEmprunteur />
    </div>
  );
};
